import initializeCLPStore from './initializeCLPStore';
import { makeGetRequest } from 'owa-ows-gateway';
import processCLPLabelResponse from '../../service/processCLPLabelResponse';
import { logCLPLabelLoadDatapoint } from '../../utils/clp/logCLPDatapoints';

const CLP_LABEL_ENDPOINT_URI = '/compliancepolicy/api/v1.0/user/label';
export let pendingLoadLabelPromise: Promise<void> = null;

export default function loadCLPUserLabels() {
    pendingLoadLabelPromise = makeGetRequest(CLP_LABEL_ENDPOINT_URI).then(resp => {
        initializeCLPStore(processCLPLabelResponse(resp));
        logCLPLabelLoadDatapoint(resp);
        pendingLoadLabelPromise = null;
    });
}
